var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 8.17163 17.3285 7.49999 16.5 7.49999L10.5 7.49993L10.5 1.49993C10.5 0.671565 9.82846 -7.19934e-05 9 -7.92923e-05C8.17154 -8.65913e-05 7.5 0.671538 7.5 1.49991L7.5 7.49991L1.5 7.49986C0.671539 7.49985 -3.57193e-07 8.17147 -3.93402e-07 8.99984C-4.29612e-07 9.82821 0.671539 10.4998 1.5 10.4999L7.5 10.4999L7.5 16.4999C7.5 17.3283 8.17154 17.9999 9 17.9999C9.82846 17.9999 10.5 17.3283 10.5 16.4999L10.5 10.4999L16.5 10.5C17.3285 10.5 18 9.82837 18 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f15fac61bfb1afee31ac7c445d4033d1.svg";
export { ForwardRef as ReactComponent };